import { render, staticRenderFns } from "./PeriodsIndex.vue?vue&type=template&id=6c9ff37c"
import script from "./PeriodsIndex.vue?vue&type=script&lang=js"
export * from "./PeriodsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports